import styled, { css } from 'styled-components'
import { CheckedStatus } from '.'
import FormControl from '../FormControl'

export const CheckBoxFormControl = styled(FormControl)`
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;

  label {
    margin-left: 8px;
    padding: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
  }

  & > [role='checkbox'] {
    background-color: var(--gray-0);
    cursor: pointer;
  }

  &.disabled > [role='checkbox'],
  &.readonly > [role='checkbox'] {
    cursor: default;
  }

  &.checked > [role='checkbox'],
  &.checked.disabled > [role='checkbox'],
  &.checked.readonly > [role='checkbox'] {
    background-color: var(--blue-100);
  }

  &:not(.checked).disabled > [role='checkbox'],
  &:not(.checked).readonly > [role='checkbox'] {
    background-color: var(--blueish-50);
  }
`

export const CheckBoxInput = styled.span`
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;

  box-sizing: border-box;
  border: 1px solid var(--blueish-400);
  border-radius: 4px;
  display: block;

  transition: all 150ms;
  position: relative;

  svg {
    width: 14px;
    height: 14px;
    color: var(--blue-500);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;

    pointer-events: none;
  }

  :focus {
    border: 2px solid var(--blue-500);
  }
`
